import { Redirect, Switch, useLocation } from "react-router-dom";
import Sidebar from "../components/globals/Sidebar";
import AdminTopbar from "../components/globals/AdminTopbar";
import { routes } from "../routes";
import { useAdminData } from "../views/Admin/customHooks/useAdminData";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import NavBar from "../components/globals/NavBar";

const Admin = () => {
  const { getRoutes } = useAdminData();
  const location = useLocation();
  const { layout } = useSelector((state) => state.redux);
  const [collapsed, setCollapsed] = useState(layout === "navbar");

  useEffect(() => {
    if (layout === "navbar") {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [layout]);


  useEffect(() => {
    if (!location.pathname.startsWith('/admin/categories') && !location.pathname.startsWith('/admin/category-details')) {
      localStorage.removeItem("categorySearch");
    }
    if (!location.pathname.startsWith('/admin/sub-categories') && !location.pathname.startsWith('/admin/subCategory-details')) {
      localStorage.removeItem("subCategorySearch");
    }
  }, [location.pathname]);

  return (
    <>
      {
        layout === "navbar" && collapsed ? (
          <>
            <NavBar
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 10,
              }}
            />

            <div className="d-flex flex-row w-full " style={{ paddingTop: "calc(40px + 1rem)", height: 'auto', overflowY: 'scroll' }}>
              <div className={`px-2 px-lg-3 py-4 w-100 `}>
                <Switch>
                  {getRoutes(routes)}
                  <Redirect from="*" to="/admin/index" />
                </Switch>
              </div>
            </div>
          </>

        ) :
          (
            <div className="admin-root">
              <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
              <div className="admin-content" style={{
                marginLeft: collapsed ? '72px' : '240px'
              }}>
                <AdminTopbar collapsed={collapsed} setCollapsed={setCollapsed} />
                <div className="px-3 py-4 w-100">
                  <Switch>
                    {getRoutes(routes)}
                    <Redirect from="*" to="/admin/index" />
                  </Switch>
                </div>
              </div>
            </div>
          )
      }
    </>
  );
};

export default Admin;
